import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Pages
import Login from './pages/auth/Login';
import Dashboard from './pages/admin/Dashboard';
import Analytics from './pages/admin/Analytics';
import Batches from './pages/admin/Batches';
import Users from './pages/admin/Users';
import Numbers from './pages/client/Numbers';
import SMSViewer from './pages/client/SMSViewer';
import GlobalSettings from './pages/superadmin/GlobalSettings';

// Components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

const AppRoutes: React.FC = () => {
  const { isAuthenticated, isAdmin, user } = useAuth();
  const isSuperAdmin = user?.role === 'superadmin';

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Navigate to={isAdmin || isSuperAdmin ? '/admin' : '/numbers'} replace />
          </ProtectedRoute>
        }
      />

      {/* Admin Routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/analytics"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <Analytics />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/batches"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <Batches />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <Users />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* SuperAdmin Routes */}
      <Route
        path="/superadmin/global-settings"
        element={
          <ProtectedRoute allowedRoles={['superadmin']}>
            <Layout>
              <GlobalSettings />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Client Routes */}
      <Route
        path="/numbers"
        element={
          <ProtectedRoute>
            <Layout>
              <Numbers />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sms"
        element={
          <ProtectedRoute>
            <Layout>
              <SMSViewer />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
